export default "__VITE_ASSET__c6c19485__"